import { Subject } from 'rxjs';

export const clearUndoStackSubject = new Subject();